(function () {
  "use strict";

  /* =========================================================
     BASIC SETUP
     ========================================================= */

  const $ = function (id) {
    return document.getElementById(id);
  };

  let scorecards = [];
  let currentPage = 0;


  /* =========================================================
     ESCAPE USER TEXT
     ========================================================= */

  function escapeHTML(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  /* =========================================================
     FORM DATA
     ========================================================= */

  function getFormData() {
    return {
      competition: $("csgCompetition").value.trim(),
      event:
  $("csgEvent").value === "__custom__"
    ? $("csgCustomEvent").value.trim()
    : $("csgEvent").value,
      round: $("csgRound").value.trim(),
      group: $("csgGroup").value.trim(),
      id: $("csgID").value.trim(),
      name: $("csgName").value.trim(),
      format: $("csgFormat").value,
      cutoff: $("csgCutoff").value.trim(),
      limit: $("csgLimit").value.trim()
    };
  }


  /* =========================================================
     ROUND FORMAT
     ========================================================= */

  function attemptCount(format) {
    switch (format) {
      case "mo3":
      case "bo3":
        return 3;

      case "bo2":
        return 2;

      case "bo1":
        return 1;

      default:
        return 5;
    }
  }


  function hasCutoff(data) {
    return (
      data.format === "cutoff" ||
      data.cutoff !== ""
    );
  }


  /* =========================================================
     CREATE ATTEMPT ROW
     ========================================================= */

  function makeAttempt(number, total, cutoff, cutoffAfter) {
  let className = "csg-attempt";

  if (number > total) {
    className += " csg-disabled";
  }

  if (number === cutoffAfter && cutoff) {
    className += " csg-cutoff-after";
  }

  return `
    <div class="${className}">

      <div class="csg-num">
        ${number}
      </div>

      <div class="csg-box first"></div>
      <div class="csg-box"></div>
      <div class="csg-box"></div>
      <div class="csg-box"></div>

    </div>
  `;
}


  /* =========================================================
     CREATE HTML SCORECARD
     ========================================================= */

 function createCard(data) {
  const total = attemptCount(data.format);
  const cutoff = hasCutoff(data);
  const cutoffAfter = data.format === "mo3" ? 1 : 2;

  const card = document.createElement("div");

    card.className = "csg-card";

    card.innerHTML = `

      <div class="csg-comp-title">
        ${escapeHTML(data.competition)}
      </div>


      <div class="csg-label-row">

        <div>Event</div>
        <div>Round</div>
        <div>Group</div>

      </div>


      <div class="csg-event-row">

        <div>
          ${escapeHTML(data.event)}
        </div>

        <div>
          ${escapeHTML(data.round)}
        </div>

        <div>
          ${escapeHTML(data.group)}
        </div>

      </div>


      <div class="csg-name-labels">

        <div>ID</div>
        <div>Name</div>

      </div>


      <div class="csg-name-row">

        <div class="csg-id">
          ${escapeHTML(data.id)}
        </div>

        <div class="csg-name">
          ${escapeHTML(data.name)}
        </div>

      </div>


      <div class="csg-attempt-section">


        <div class="csg-attempt-head">

          <div></div>
          <div>Scr</div>
          <div>Result</div>
          <div>Judge</div>
          <div>Comp</div>

        </div>


    ${makeAttempt(1, total, cutoff, cutoffAfter)}
${makeAttempt(2, total, cutoff, cutoffAfter)}
${makeAttempt(3, total, cutoff, cutoffAfter)}
${makeAttempt(4, total, cutoff, cutoffAfter)}
${makeAttempt(5, total, cutoff, cutoffAfter)}


        <div class="csg-extra-label">
          Extra attempt
        </div>


        <div class="csg-extra">

          <div class="csg-dash">
            −
          </div>

          <div class="csg-box first"></div>
          <div class="csg-box"></div>
          <div class="csg-box"></div>
          <div class="csg-box"></div>

        </div>

      </div>


      <div class="csg-bottom">

        <div>
          Cut off:
          <strong>
            ${escapeHTML(data.cutoff)}
          </strong>
        </div>

        <div>
          Time limit:
          <strong>
            ${escapeHTML(data.limit)}
          </strong>
        </div>

      </div>
    `;

    return card;
  }


  /* =========================================================
     CREATE BLANK A6 QUARTER
     ========================================================= */

  function createBlankCard() {
    const blank = document.createElement("div");

    blank.className = "csg-card csg-blank-card";

    return blank;
  }


  /* =========================================================
     LIVE PREVIEW
     ========================================================= */
function updateCustomEventField() {
  const eventSelect = $("csgEvent");
  const customEvent = $("csgCustomEvent");

  if (!eventSelect || !customEvent) {
    return;
  }

  const isCustom =
    eventSelect.value === "__custom__";

  customEvent.style.display =
    isCustom ? "block" : "none";

  updatePreview();
}
  function updatePreview() {
    const preview = $("csgPreview");

    if (!preview) {
      return;
    }

    const data = getFormData();

    preview.innerHTML = "";

    preview.appendChild(
      createCard(data)
    );

    const note = $("csgCutoffNote");

    if (note) {
      note.classList.toggle(
        "show",
        hasCutoff(data)
      );
    }
  }


  /* =========================================================
     PAGE COUNT
     ========================================================= */

  function pageCount() {
    return Math.max(
      1,
      Math.ceil(scorecards.length / 4)
    );
  }


  /* =========================================================
     A4 PAGE PREVIEW
     ========================================================= */

  function renderPage() {
    const preview = $("csgPagePreview");

    if (!preview) {
      return;
    }

    const pages = pageCount();

    if (currentPage >= pages) {
      currentPage = pages - 1;
    }

    if (currentPage < 0) {
      currentPage = 0;
    }

    preview.innerHTML = "";

    const start = currentPage * 4;

    for (let i = 0; i < 4; i++) {
      const data = scorecards[start + i];

      if (data) {
        preview.appendChild(
          createCard(data)
        );
      } else {
        preview.appendChild(
          createBlankCard()
        );
      }
    }


    if ($("csgPageNumber")) {
      $("csgPageNumber").textContent =
        "Page " +
        (currentPage + 1) +
        " of " +
        pages;
    }


    if ($("csgPrev")) {
      $("csgPrev").disabled =
        currentPage === 0;
    }


    if ($("csgNext")) {
      $("csgNext").disabled =
        currentPage >= pages - 1;
    }


    if ($("csgPDFButton")) {
      $("csgPDFButton").disabled =
        scorecards.length === 0;
    }


    if ($("csgPrintButton")) {
      $("csgPrintButton").disabled =
        scorecards.length === 0;
    }


    if ($("csgSheetInfo")) {
      if (scorecards.length === 0) {
        $("csgSheetInfo").textContent =
          "No scorecards added yet.";
      } else {
        const pagesNeeded =
          Math.ceil(scorecards.length / 4);

        $("csgSheetInfo").textContent =
          scorecards.length +
          " scorecard" +
          (scorecards.length === 1 ? "" : "s") +
          " · " +
          pagesNeeded +
          " A4 page" +
          (pagesNeeded === 1 ? "" : "s");
      }
    }
  }


  /* =========================================================
     SCORECARD QUEUE
     ========================================================= */

  function renderList() {
    const list = $("csgQueue");

    if (!list) {
      return;
    }

    list.innerHTML = "";

    if (scorecards.length === 0) {
      const empty =
        document.createElement("div");

      empty.className =
        "csg-queue-card";

      empty.textContent =
        "No scorecards added.";

      list.appendChild(empty);

      return;
    }


    scorecards.forEach(function (data, index) {
      const item =
        document.createElement("div");

      item.className =
        "csg-queue-card";

      item.innerHTML = `

        <strong>
          ${escapeHTML(
            data.name ||
            "Unnamed competitor"
          )}
        </strong>

        ${escapeHTML(data.event)}

        · Group
        ${escapeHTML(
          data.group || "—"
        )}

        <br>

        ID:
        ${escapeHTML(
          data.id || "—"
        )}

        <span class="csg-remove">
          Click to remove
        </span>
      `;


      item.addEventListener(
        "click",
        function () {
          scorecards.splice(
            index,
            1
          );

          if (
            currentPage >=
            pageCount()
          ) {
            currentPage =
              pageCount() - 1;
          }

          renderAll();
        }
      );


      list.appendChild(item);
    });
  }


  /* =========================================================
     RENDER EVERYTHING
     ========================================================= */

  function renderAll() {
    renderPage();
    renderList();
  }


  /* =========================================================
     ADD SCORECARD
     ========================================================= */

  function addScorecard() {
    scorecards.push({
      ...getFormData()
    });

    currentPage =
      Math.floor(
        (scorecards.length - 1) / 4
      );


    /*
      Keep competition, event, round, group,
      format, cutoff and time limit.

      Clear only the competitor information.
    */

    $("csgID").value = "";
    $("csgName").value = "";


    updatePreview();
    renderAll();

    $("csgID").focus();
  }


  /* =========================================================
     CLEAR CURRENT COMPETITOR
     ========================================================= */

  function clearCompetitor() {
    $("csgID").value = "";
    $("csgName").value = "";

    updatePreview();

    $("csgID").focus();
  }


  /* =========================================================
     CLEAR ALL SCORECARDS
     ========================================================= */

  function clearAll() {
    scorecards = [];
    currentPage = 0;

    renderAll();
  }


  /* =========================================================
     LOAD jsPDF ONLY WHEN REQUIRED
     ========================================================= */

  function loadJsPDF() {
    return new Promise(
      function (resolve, reject) {

        /*
          Already available.
        */

        if (
          window.jspdf &&
          window.jspdf.jsPDF
        ) {
          resolve();
          return;
        }


        /*
          Already loading.
        */

        const existing =
          document.getElementById(
            "csg-jspdf-library"
          );

        if (existing) {
          existing.addEventListener(
            "load",
            function () {
              if (
                window.jspdf &&
                window.jspdf.jsPDF
              ) {
                resolve();
              } else {
                reject(
                  new Error(
                    "jsPDF loaded but was unavailable."
                  )
                );
              }
            }
          );

          existing.addEventListener(
            "error",
            function () {
              reject(
                new Error(
                  "jsPDF failed to load."
                )
              );
            }
          );

          return;
        }


        /*
          Load library dynamically.
        */

        const script =
          document.createElement("script");

        script.id =
          "csg-jspdf-library";

        script.src =
          "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.2/jspdf.umd.min.js";

        script.async = true;


        script.onload =
          function () {
            if (
              window.jspdf &&
              window.jspdf.jsPDF
            ) {
              resolve();
            } else {
              reject(
                new Error(
                  "jsPDF loaded but was unavailable."
                )
              );
            }
          };


        script.onerror =
          function () {
            reject(
              new Error(
                "jsPDF failed to load."
              )
            );
          };


        document.head.appendChild(
          script
        );
      }
    );
  }


  /* =========================================================
     PDF GENERATOR
     ========================================================= */

  function generatePDF() {
    if (scorecards.length === 0) {
      return;
    }

    if (
      !window.jspdf ||
      !window.jspdf.jsPDF
    ) {
      alert(
        "The PDF generator has not loaded."
      );

      return;
    }


    const jsPDF =
      window.jspdf.jsPDF;


    const pdf =
      new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true
      });


    const pages =
      Math.ceil(
        scorecards.length / 4
      );


    for (
      let page = 0;
      page < pages;
      page++
    ) {

      if (page > 0) {
        pdf.addPage(
          "a4",
          "portrait"
        );
      }


      for (
        let position = 0;
        position < 4;
        position++
      ) {

        const index =
          page * 4 + position;

        if (
          index >=
          scorecards.length
        ) {
          continue;
        }


        const x =
          (position % 2) * 105;

        const y =
          Math.floor(
            position / 2
          ) * 148.5;


        drawPDFCard(
          pdf,
          scorecards[index],
          x,
          y
        );
      }


      /*
        A4 cutting guides.
      */

      pdf.setDrawColor(180);
      pdf.setLineWidth(0.2);

      pdf.setLineDashPattern(
        [1.5, 1.5],
        0
      );


      pdf.line(
        105,
        0,
        105,
        297
      );


      pdf.line(
        0,
        148.5,
        210,
        148.5
      );


      pdf.setLineDashPattern(
        [],
        0
      );

      pdf.setDrawColor(0);
    }


    /*
      Filename.
    */

    let filename =
      scorecards[0].competition ||
      "cubing-competition";


    filename =
      filename
        .replace(
          /[^a-z0-9]+/gi,
          "-"
        )
        .replace(
          /^-+|-+$/g,
          ""
        )
        .toLowerCase();


    pdf.save(
      filename +
      "-scorecards.pdf"
    );
  }


  /* =========================================================
     DRAW ONE VECTOR SCORECARD
     All dimensions are in millimetres.
     ========================================================= */

  function drawPDFCard(
    pdf,
    data,
    originX,
    originY
  ) {

    const X =
      function (value) {
        return originX + value;
      };

    const Y =
      function (value) {
        return originY + value;
      };


    /*
      Internal scorecard geometry.
    */

    const left = 5;
    const right = 100;
    const width = 95;

    const lineWidth = 0.5;


    pdf.setDrawColor(0);
    pdf.setTextColor(0);
    pdf.setLineWidth(lineWidth);

    pdf.setLineDashPattern(
      [],
      0
    );


    /* =====================================================
       COMPETITION TITLE
       ===================================================== */

    pdf.setFont(
      "helvetica",
      "bold"
    );

    pdf.setFontSize(12.75);


    pdf.text(
      String(
        data.competition || ""
      ),
      X(52.5),
      Y(10),
      {
        align: "center",
        maxWidth: 90
      }
    );


    /* =====================================================
       EVENT
       ===================================================== */

    const eventLabelY = 19;

    const eventBoxTop = 20;
    const eventBoxHeight = 8;

    const eventRoundX = 74;
    const eventGroupX = 87;


    pdf.setFont(
      "helvetica",
      "normal"
    );

    pdf.setFontSize(7.1);


    pdf.text(
      "Event",
      X(left),
      Y(eventLabelY)
    );


    pdf.text(
      "Round",
      X(80.5),
      Y(eventLabelY),
      {
        align: "center"
      }
    );


    pdf.text(
      "Group",
      X(93.5),
      Y(eventLabelY),
      {
        align: "center"
      }
    );


    pdf.setLineWidth(
      lineWidth
    );


    pdf.rect(
      X(left),
      Y(eventBoxTop),
      width,
      eventBoxHeight
    );


    pdf.line(
      X(eventRoundX),
      Y(eventBoxTop),
      X(eventRoundX),
      Y(
        eventBoxTop +
        eventBoxHeight
      )
    );


    pdf.line(
      X(eventGroupX),
      Y(eventBoxTop),
      X(eventGroupX),
      Y(
        eventBoxTop +
        eventBoxHeight
      )
    );


    pdf.setFontSize(8.5);


    pdf.text(
      String(
        data.event || ""
      ),
      X(left + 1.5),
      Y(
        eventBoxTop + 5.2
      ),
      {
        maxWidth:
          eventRoundX -
          left -
          3
      }
    );


    pdf.text(
      String(
        data.round || ""
      ),
      X(80.5),
      Y(
        eventBoxTop + 5.2
      ),
      {
        align: "center"
      }
    );


    pdf.text(
      String(
        data.group || ""
      ),
      X(93.5),
      Y(
        eventBoxTop + 5.2
      ),
      {
        align: "center"
      }
    );


    /* =====================================================
       ID / NAME
       ===================================================== */

    const nameLabelY = 32;

    const nameTop = 33;
    const nameHeight = 8;

    const idSplit = 18;


    pdf.setFontSize(6.8);


    pdf.text(
      "ID",
      X(left),
      Y(nameLabelY)
    );


    pdf.text(
      "Name",
      X(idSplit + 2),
      Y(nameLabelY)
    );


    pdf.setLineWidth(
      lineWidth
    );


    pdf.rect(
      X(left),
      Y(nameTop),
      width,
      nameHeight
    );


    pdf.line(
      X(idSplit),
      Y(nameTop),
      X(idSplit),
      Y(
        nameTop +
        nameHeight
      )
    );


    pdf.setFontSize(8.5);


    pdf.text(
      String(
        data.id || ""
      ),
      X(
        (left + idSplit) / 2
      ),
      Y(
        nameTop + 5.2
      ),
      {
        align: "center"
      }
    );


    pdf.text(
      String(
        data.name || ""
      ),
      X(idSplit + 2),
      Y(
        nameTop + 5.2
      ),
      {
        maxWidth:
          right -
          idSplit -
          4
      }
    );


    /* =====================================================
       ATTEMPT COLUMNS
       ===================================================== */

    const numberWidth = 5;
    const scrWidth = 12;
    const judgeWidth = 13;
    const compWidth = 13;


    const resultWidth =
      width -
      numberWidth -
      scrWidth -
      judgeWidth -
      compWidth;


    const boxesLeft =
      left +
      numberWidth;


    const scrRight =
      boxesLeft +
      scrWidth;


    const resultRight =
      scrRight +
      resultWidth;


    const judgeRight =
      resultRight +
      judgeWidth;


    const compRight =
      judgeRight +
      compWidth;


    /* =====================================================
       ATTEMPT HEADINGS
       ===================================================== */

    const attemptHeadingY = 50;


    pdf.setFont(
      "helvetica",
      "normal"
    );

    pdf.setFontSize(6.5);


    pdf.text(
      "Scr",
      X(
        boxesLeft +
        scrWidth / 2
      ),
      Y(attemptHeadingY),
      {
        align: "center"
      }
    );


    pdf.text(
      "Result",
      X(
        scrRight +
        resultWidth / 2
      ),
      Y(attemptHeadingY),
      {
        align: "center"
      }
    );


    pdf.text(
      "Judge",
      X(
        resultRight +
        judgeWidth / 2
      ),
      Y(attemptHeadingY),
      {
        align: "center"
      }
    );


    pdf.text(
      "Comp",
      X(
        judgeRight +
        compWidth / 2
      ),
      Y(attemptHeadingY),
      {
        align: "center"
      }
    );


    /* =====================================================
   ATTEMPTS
   ===================================================== */

const total =
  attemptCount(
    data.format
  );


const cutoff =
  hasCutoff(data);


const cutoffAfter =
  data.format === "mo3" ? 1 : 2;


const rowHeight = 8;

let rowTop = 51;


for (
  let attempt = 1;
  attempt <= 5;
  attempt++
) {

  drawPDFAttemptRow(
    pdf,
    X,
    Y,
    attempt,
    total,
    rowTop,
    rowHeight,
    left,
    boxesLeft,
    scrRight,
    resultRight,
    judgeRight,
    compRight,
    lineWidth
  );


  /*
    Cutoff line between attempts.
    After attempt 1 for Mean of 3,
    after attempt 2 for Average of 5.
  */

  if (
    attempt === cutoffAfter &&
    cutoff
  ) {

    pdf.setDrawColor(100);
    pdf.setLineWidth(0.3);

    pdf.setLineDashPattern(
      [1.3, 1.3],
      0
    );


    pdf.line(
      X(boxesLeft),
      Y(rowTop + 10.1),
      X(compRight),
      Y(rowTop + 10.1)
    );


    pdf.setLineDashPattern(
      [],
      0
    );

    pdf.setDrawColor(0);

    rowTop += 12.2;

  } else {

    rowTop += 10;

  }
}

    /* =====================================================
       EXTRA ATTEMPT
       ===================================================== */

    const extraLabelY =
      rowTop + 0.5;


    const extraTop =
      rowTop + 2;


    pdf.setFont(
      "helvetica",
      "normal"
    );

    pdf.setFontSize(6.8);


    pdf.text(
      "Extra attempt",
      X(boxesLeft),
      Y(extraLabelY)
    );


    pdf.setFont(
      "helvetica",
      "bold"
    );

    pdf.setFontSize(11);


    pdf.text(
      "−",
      X(left),
      Y(
        extraTop + 5.3
      )
    );


    pdf.setLineWidth(
      lineWidth
    );


    pdf.rect(
      X(boxesLeft),
      Y(extraTop),
      compRight -
      boxesLeft,
      rowHeight
    );


    pdf.line(
      X(scrRight),
      Y(extraTop),
      X(scrRight),
      Y(
        extraTop +
        rowHeight
      )
    );


    pdf.line(
      X(resultRight),
      Y(extraTop),
      X(resultRight),
      Y(
        extraTop +
        rowHeight
      )
    );


    pdf.line(
      X(judgeRight),
      Y(extraTop),
      X(judgeRight),
      Y(
        extraTop +
        rowHeight
      )
    );


    /* =====================================================
       CUTOFF / TIME LIMIT
       ===================================================== */

    const bottomY =
      extraTop + 17;


    pdf.setFont(
      "helvetica",
      "normal"
    );

    pdf.setFontSize(7.7);


    const cutoffText =
      data.cutoff
        ? "Cut off: " +
          data.cutoff
        : "Cut off:";


    const limitText =
      data.limit
        ? "Time limit: " +
          data.limit
        : "Time limit:";


    pdf.text(
      cutoffText,
      X(boxesLeft),
      Y(bottomY)
    );


    pdf.text(
      limitText,
      X(right),
      Y(bottomY),
      {
        align: "right"
      }
    );
  }


  /* =========================================================
     DRAW ONE PDF ATTEMPT ROW
     ========================================================= */

  function drawPDFAttemptRow(
    pdf,
    X,
    Y,
    attempt,
    total,
    rowTop,
    rowHeight,
    left,
    boxesLeft,
    scrRight,
    resultRight,
    judgeRight,
    compRight,
    lineWidth
  ) {

    /*
      Attempt number.
    */

    pdf.setFont(
      "helvetica",
      "bold"
    );

    pdf.setFontSize(11);


    pdf.text(
      String(attempt),
      X(left),
      Y(
        rowTop + 5.4
      )
    );


    /*
      Boxes.
    */

    pdf.setDrawColor(0);

    pdf.setLineWidth(
      lineWidth
    );


    pdf.rect(
      X(boxesLeft),
      Y(rowTop),
      compRight -
      boxesLeft,
      rowHeight
    );


    pdf.line(
      X(scrRight),
      Y(rowTop),
      X(scrRight),
      Y(
        rowTop +
        rowHeight
      )
    );


    pdf.line(
      X(resultRight),
      Y(rowTop),
      X(resultRight),
      Y(
        rowTop +
        rowHeight
      )
    );


    pdf.line(
      X(judgeRight),
      Y(rowTop),
      X(judgeRight),
      Y(
        rowTop +
        rowHeight
      )
    );


    /*
      Strike through attempts that
      aren't part of the format.
    */

    if (
      attempt >
      total
    ) {

      pdf.setDrawColor(130);

      pdf.setLineWidth(
        0.35
      );


      pdf.line(
        X(boxesLeft),
        Y(
          rowTop +
          rowHeight / 2 +
          0.5
        ),
        X(compRight),
        Y(
          rowTop +
          rowHeight / 2 -
          0.5
        )
      );


      pdf.setDrawColor(0);
    }
  }


  /* =========================================================
     CLEAN DIRECT PRINT WINDOW
     ========================================================= */

  function printDirectly() {
    if (scorecards.length === 0) {
      return;
    }


    const printWindow =
      window.open(
        "",
        "_blank"
      );


    if (!printWindow) {
      alert(
        "Your browser blocked the print window. Please allow pop-ups for this page and try again."
      );

      return;
    }


    let pagesHTML = "";


    const pages =
      Math.ceil(
        scorecards.length / 4
      );


    for (
      let page = 0;
      page < pages;
      page++
    ) {

      let cardsHTML = "";


      for (
        let position = 0;
        position < 4;
        position++
      ) {

        const index =
          page * 4 +
          position;


        if (
          index <
          scorecards.length
        ) {

          const temp =
            createCard(
              scorecards[index]
            );

          cardsHTML +=
            temp.outerHTML;

        } else {

          cardsHTML +=
            '<div class="csg-card"></div>';

        }
      }


      pagesHTML +=
        '<div class="print-page">' +
        cardsHTML +
        '</div>';
    }


    printWindow.document.open();


    printWindow.document.write(`
<!doctype html>

<html>

<head>

<meta charset="utf-8">

<title>
  Cubing Competition Scorecards
</title>

<style>

@page {
  size:A4 portrait;
  margin:0;
}

* {
  box-sizing:border-box;
}

html,
body {
  margin:0;
  padding:0;
  background:#fff;
  font-family:Arial,Helvetica,sans-serif;
}

.print-page {
  width:210mm;
  height:297mm;

  display:grid;

  grid-template-columns:
    105mm 105mm;

  grid-template-rows:
    148.5mm 148.5mm;

  page-break-after:always;
  break-after:page;
}

.print-page:last-child {
  page-break-after:auto;
  break-after:auto;
}

.csg-card {
  --score-line:.50mm;

  position:relative;

  width:105mm;
  height:148.5mm;

  padding:
    6mm 5mm 4mm;

  overflow:hidden;

  background:#fff;
  color:#000;

  font-family:
    Arial,
    Helvetica,
    sans-serif;
}

.csg-comp-title {
  display:flex;

  width:100%;
  height:12mm;

  justify-content:center;
  align-items:flex-start;

  text-align:center;

  font-size:4.5mm;
  font-weight:700;
  line-height:1.05;
}

.csg-label-row {
  display:grid;

  grid-template-columns:
    minmax(0,1fr)
    13mm
    13mm;

  width:100%;
  height:5mm;

  align-items:end;

  font-size:2.5mm;
  line-height:1;
}

.csg-label-row > div {
  padding-bottom:.5mm;
}

.csg-label-row > div:nth-child(2),
.csg-label-row > div:nth-child(3) {
  text-align:center;
}

.csg-event-row {
  display:grid;

  grid-template-columns:
    minmax(0,1fr)
    13mm
    13mm;

  width:100%;
  height:8mm;

  border:
    var(--score-line)
    solid
    #000;
}

.csg-event-row > div {
  display:flex;

  min-width:0;

  align-items:center;

  padding:
    0 1.5mm;

  border-right:
    var(--score-line)
    solid
    #000;

  font-size:3mm;

  white-space:nowrap;
  overflow:hidden;
}

.csg-event-row > div:nth-child(2),
.csg-event-row > div:nth-child(3) {
  justify-content:center;
  padding:0;
}

.csg-event-row > div:last-child {
  border-right:0;
}

.csg-name-labels {
  display:grid;

  grid-template-columns:
    13mm
    minmax(0,1fr);

  width:100%;
  height:4.5mm;

  align-items:end;

  font-size:2.4mm;
  line-height:1;
}

.csg-name-labels > div {
  padding-bottom:.5mm;
}

.csg-name-labels > div:last-child {
  padding-left:2mm;
}

.csg-name-row {
  display:grid;

  grid-template-columns:
    13mm
    minmax(0,1fr);

  width:100%;
  height:8mm;

  border:
    var(--score-line)
    solid
    #000;
}

.csg-name-row > div {
  display:flex;
  align-items:center;
  font-size:3mm;
}

.csg-id {
  justify-content:center;

  border-right:
    var(--score-line)
    solid
    #000;
}

.csg-name {
  padding-left:2mm;
}

.csg-attempt-section {
  width:100%;
  margin-top:5mm;
}

.csg-attempt-head,
.csg-attempt,
.csg-extra {
  grid-template-columns:
    5mm
    12mm
    minmax(0,1fr)
    13mm
    13mm;
}

.csg-attempt-head {
  display:grid;

  width:100%;
  height:5mm;

  align-items:end;

  font-size:2.3mm;
}

.csg-attempt-head > div {
  display:flex;

  height:100%;

  padding-bottom:.6mm;

  align-items:flex-end;
  justify-content:center;
}

.csg-attempt-head > div:first-child {
  visibility:hidden;
}

.csg-attempt {
  display:grid;

  width:100%;
  height:8mm;

  margin-bottom:2mm;

  position:relative;
}

.csg-num {
  display:flex;

  height:8mm;

  align-items:center;

  font-size:4mm;
  font-weight:700;
}

.csg-box {
  display:block;

  border-top:
    var(--score-line)
    solid
    #000;

  border-bottom:
    var(--score-line)
    solid
    #000;

  border-right:
    var(--score-line)
    solid
    #000;
}

.csg-box.first {
  border-left:
    var(--score-line)
    solid
    #000;
}

.csg-cutoff-after {
  margin-bottom:4.2mm;
}

.csg-cutoff-after:after {
  content:"";

  position:absolute;

  left:5mm;
  right:0;
  bottom:-2.2mm;

  border-bottom:
    .30mm
    dashed
    #666;
}

.csg-disabled {
  opacity:.32;
}

.csg-disabled:before {
  content:"";

  position:absolute;

  left:5mm;
  right:0;
  top:50%;

  border-top:
    .4mm
    solid
    #555;

  transform:
    rotate(-3deg);
}

.csg-extra-label {
  display:flex;

  height:4.5mm;

  margin-left:5mm;

  align-items:flex-end;

  font-size:2.4mm;
}

.csg-extra {
  display:grid;

  width:100%;
  height:8mm;

  margin-top:1mm;
}

.csg-dash {
  display:flex;

  height:8mm;

  align-items:center;

  font-size:4mm;
  font-weight:700;
}

.csg-bottom {
  display:grid;

  grid-template-columns:
    1fr 1fr;

  margin:
    4mm 0 0 5mm;

  font-size:2.7mm;
}

.csg-bottom > div:last-child {
  text-align:right;
}

.csg-bottom strong {
  font-weight:400;
}

.print-page > .csg-card:nth-child(odd) {
  border-right:
    .2mm
    dashed
    #bbb;
}

.print-page > .csg-card:nth-child(-n+2) {
  border-bottom:
    .2mm
    dashed
    #bbb;
}

</style>

</head>

<body>

${pagesHTML}

<script>

window.onload =
  function () {

    setTimeout(
      function () {
        window.print();
      },
      250
    );

  };

<\/script>

</body>

</html>
    `);


    printWindow.document.close();
  }


  /* =========================================================
     EVENT LISTENERS
     ========================================================= */

  function attachEvents() {

    [
   
  "csgCompetition",
  "csgEvent",
  "csgCustomEvent",
  "csgRound",
  "csgGroup",
  "csgID",
  "csgName",
  "csgFormat",
  "csgCutoff",
  "csgLimit"

    ].forEach(
      function (id) {

        const element =
          $(id);

        if (!element) {
          return;
        }


        element.addEventListener(
          "input",
          updatePreview
        );


        element.addEventListener(
          "change",
          updatePreview
        );
      }
    );


    if ($("csgAdd")) {
      $("csgAdd").addEventListener(
        "click",
        addScorecard
      );
    }


    if ($("csgClearForm")) {
      $("csgClearForm").addEventListener(
        "click",
        clearCompetitor
      );
    }


    if ($("csgClearSheet")) {
      $("csgClearSheet").addEventListener(
        "click",
        clearAll
      );
    }


    if ($("csgPrev")) {
      $("csgPrev").addEventListener(
        "click",
        function () {

          if (
            currentPage >
            0
          ) {

            currentPage--;

            renderPage();
          }
        }
      );
    }


    if ($("csgNext")) {
      $("csgNext").addEventListener(
        "click",
        function () {

          if (
            currentPage <
            pageCount() - 1
          ) {

            currentPage++;

            renderPage();
          }
        }
      );
    }


    if ($("csgPDFButton")) {
      $("csgPDFButton").addEventListener(
        "click",
        function () {

          if (
            scorecards.length ===
            0
          ) {
            return;
          }


          const button =
            $("csgPDFButton");

          const originalText =
            button.textContent;


          button.disabled = true;

          button.textContent =
            "Generating PDF…";


          loadJsPDF()

            .then(
              function () {

                generatePDF();

              }
            )

            .catch(
              function (error) {

                console.error(
                  "Scorecard PDF error:",
                  error
                );


                alert(
                  "The PDF generator could not be loaded. Please refresh the page and try again."
                );

              }
            )

            .finally(
              function () {

                button.textContent =
                  originalText;

                button.disabled =
                  scorecards.length === 0;

              }
            );

        }
      );
    }


    if ($("csgPrintButton")) {
      $("csgPrintButton").addEventListener(
        "click",
        printDirectly
      );
    }
    if ($("csgEvent")) {
  $("csgEvent").addEventListener(
    "change",
    updateCustomEventField
  );
}
  }


   /* =========================================================
     INITIALISE GENERATOR
     ========================================================= */

  function initScorecardGenerator() {

    const generator =
      document.getElementById(
        "cube-scorecard-generator"
      );

    if (!generator) {
      return;
    }

    /*
      Store the initialisation state on the actual
      generator element rather than globally.

      If Shopify replaces the section, the replacement
      element won't have this attribute and will therefore
      initialise correctly.
    */

    if (
      generator.dataset.csgInitialised ===
      "true"
    ) {
      return;
    }

    generator.dataset.csgInitialised =
      "true";

   attachEvents();
updateCustomEventField();
renderAll();
  }


  /* =========================================================
     INITIAL PAGE LOAD
     ========================================================= */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initScorecardGenerator
    );

  } else {

    initScorecardGenerator();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    "shopify:section:load",
    function () {

      /*
        Wait until Shopify has actually inserted the
        replacement section into the DOM.
      */

      setTimeout(
        initScorecardGenerator,
        0
      );

    }
  );


  /* =========================================================
     SHOPIFY DESIGN MODE FALLBACK

     Some theme-editor updates don't fire in exactly the
     same way as a normal section load. Observe DOM changes
     while we're inside the theme editor and initialise a
     newly inserted generator if necessary.
     ========================================================= */

  if (
    window.Shopify &&
    Shopify.designMode
  ) {

    const observer =
      new MutationObserver(
        function () {

          const generator =
            document.getElementById(
              "cube-scorecard-generator"
            );

          if (
            generator &&
            generator.dataset.csgInitialised !==
            "true"
          ) {

            initScorecardGenerator();

          }

        }
      );

    observer.observe(
      document.documentElement,
      {
        childList:true,
        subtree:true
      }
    );

  }

})();